const ProblemSolutionSection = () => {
    return (
        <section className="py-20 bg-white">
            <div className="container mx-auto px-4">
                <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-10 items-center">

                    {/* Problem */}
                    <div className="bg-red-50 border border-red-100 rounded-2xl p-8">
                        <div className="text-red-500 text-3xl mb-4">
                            <i className="fas fa-times-circle"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-800 mb-5">Without StockEasy…</h3>
                        <ul className="space-y-3 text-gray-600 text-sm">
                            <li className="flex gap-2">
                                <i className="fas fa-times text-red-400 mt-1 flex-shrink-0"></i>
                                Manual counting is slow, error-prone, and costly
                            </li>
                            <li className="flex gap-2">
                                <i className="fas fa-times text-red-400 mt-1 flex-shrink-0"></i>
                                Wrong parts slip through unnoticed until it's too late
                            </li>
                            <li className="flex gap-2">
                                <i className="fas fa-times text-red-400 mt-1 flex-shrink-0"></i>
                                Staff spend hours reconciling spreadsheets
                            </li>
                            <li className="flex gap-2">
                                <i className="fas fa-times text-red-400 mt-1 flex-shrink-0"></i>
                                No mobile solution — fixed to a desk
                            </li>
                        </ul>
                    </div>

                    {/* Solution */}
                    <div className="bg-green-50 border border-green-100 rounded-2xl p-8">
                        <div className="text-green-500 text-3xl mb-4">
                            <i className="fas fa-check-circle"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-800 mb-5">With StockEasy…</h3>
                        <ul className="space-y-3 text-gray-600 text-sm">
                            <li className="flex gap-2">
                                <i className="fas fa-check text-green-500 mt-1 flex-shrink-0"></i>
                                AI scans parts in seconds — no manual counting
                            </li>
                            <li className="flex gap-2">
                                <i className="fas fa-check text-green-500 mt-1 flex-shrink-0"></i>
                                Every discrepancy flagged in real-time
                            </li>
                            <li className="flex gap-2">
                                <i className="fas fa-check text-green-500 mt-1 flex-shrink-0"></i>
                                Reports ready in one click — zero spreadsheets
                            </li>
                            <li className="flex gap-2">
                                <i className="fas fa-check text-green-500 mt-1 flex-shrink-0"></i>
                                Fully mobile — use any iOS or Android phone
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default ProblemSolutionSection;
